import * as React from 'react'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
`

const Badge = styled.span`
  flex: none;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  background-color: var(--button-color);
  color: #fff;
  font-weight: 800;
  font-size: 1.05rem;
  display: grid;
  place-items: center;
`

const Heading = styled.h3`
  margin: 0 !important;
  font-size: 1.1rem;
`

export interface StepHeadingProps {
  n: number
  text: string
}

export const StepHeading: React.FC<StepHeadingProps> = ({ n, text }) => (
  <Wrapper>
    <Badge>{n}</Badge>
    <Heading>{text}</Heading>
  </Wrapper>
)
